import classNames from 'classnames';

import { RemoteImage } from '@gem/modules/remote-storage';

import { useMediaGalleryPreviewPresenter } from './MediaGalleryPreviewItem.presenter';
import styles from './MediaGalleryPreviewItem.styles.m.css';

export const MediaGalleryPreviewItem = ({ file, selected }) => {
  const { previewUrl, onSelectFile } = useMediaGalleryPreviewPresenter(file);

  return (
    <div
      className={classNames(styles.container, {
        [styles.selected]: selected,
      })}
      onClick={!selected ? onSelectFile : undefined}
    >
      <RemoteImage
        className={styles.image}
        src={previewUrl}
        alt=""
      />
      <div className={styles.overlay}></div>
    </div>
  );
};
